import {
  ADD_TO_CART,
  REMOVE_CART_ITEM,
  TOGGLE_CART_ITEM_AMOUNT,
  CLEAR_CART,
  COUNT_CART_TOTALS,
  UPDATE_SHIPPING_FEE,
} from '../actions';
import { cartItemId } from '../utils/cartItemId';

const cart_reducer = (state, action) => {
  if (action.type === ADD_TO_CART) {
    const { product, amount, graphicFront, graphicBack, designId } =
      action.payload;
    const id = cartItemId(product._id, graphicFront, graphicBack, designId);
    const tempItem = state.cart.find((i) => i.id === id);

    if (tempItem) {
      const tempCart = state.cart.map((cartItem) => {
        if (cartItem.id !== id) return cartItem;
        if (designId) {
          // Design-Item: erneutes Hinzufügen = aktualisieren (z.B. nach
          // Bearbeiten). Menge bleibt, Grafik/Design werden übernommen.
          return { ...cartItem, graphicFront, graphicBack, designId };
        }
        let newAmount = cartItem.amount + amount;
        if (newAmount > cartItem.max) newAmount = cartItem.max;
        return { ...cartItem, amount: newAmount };
      });

      return { ...state, cart: tempCart };
    } else {
      const newItem = {
        id,
        hrefId: product._id,
        name: product.name,
        image: product.image,
        amount,
        graphicFront,
        graphicBack,
        designId: designId ?? null,
        price: product.price,
        max: product.inventory,
        leadTime: product.leadTime,
        hasCustomization: product.hasCustomization,
      };
      return { ...state, cart: [...state.cart, newItem] };
    }
  }

  if (action.type === REMOVE_CART_ITEM) {
    const tempCart = state.cart.filter((item) => item.id !== action.payload);
    return { ...state, cart: tempCart };
  }

  if (action.type === CLEAR_CART) {
    return { ...state, cart: [] };
  }

  if (action.type === TOGGLE_CART_ITEM_AMOUNT) {
    const { id, value } = action.payload;
    const tempCart = state.cart.map((item) => {
      if (item.id === id) {
        let newAmount = value;
        if (newAmount > item.max) {
          newAmount = item.max;
        }
        return { ...item, amount: newAmount };
      } else {
        return item;
      }
    });

    return { ...state, cart: tempCart };
  }

  if (action.type === COUNT_CART_TOTALS) {
    const { total_items, total_amount } = state.cart.reduce(
      (total, cartItem) => {
        const { amount, price } = cartItem;

        total.total_items += amount;
        total.total_amount += price * amount;
        return total;
      },
      {
        total_items: 0,
        total_amount: 0,
      }
    );
    return { ...state, total_items, total_amount };
  }

  if (action.type === UPDATE_SHIPPING_FEE) {
    const { newShippingFee } = action.payload;
    return { ...state, shippingFee: newShippingFee };
  }
};

export default cart_reducer;
